<template>
  <div v-show="ready">
    <app-header />
    <div class="dashboard container my-3 my-md-4 position-relative">
      <div
        class="dashboard-menu d-flex justify-content-end position-absolute w-100"
      ></div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import AppHeader from "@/layout/DashboardHeader";

import { mapGetters } from "vuex";

export default {
  components: { AppHeader },
  data() {
    return {
      ready: false
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  watch: {
    user() {
      if (!this.user) this.$router.push({ name: "Login" });
    }
  },
  mounted() {
    setTimeout(() => {
      this.ready = true;
    }, 800);
  }
};
</script>

<style lang="scss" scoped>
.dashboard {
  position: relative;
  z-index: 1;
  .dashboard-menu {
    top: -40px;
    color: #fff;
  }
  ul.notes {
    padding: 0;
    li {
      list-style-type: none;
      padding: 10px 5px;
    }
  }
}
</style>
